// HC - global cart challenge notice - 2026-07-04
(function(root) {
  'use strict';

  var doc = root.document;
  if (!doc) {
    return;
  }

  var STYLE_ID = 'ib-cart-notice-style';
  var BANNER_ID = 'ib-cart-challenge-status';
  var TOAST_ID = 'ib-cart-notice-toast';
  var ACTIVE_CLASS = 'cart-challenge-active';
  var BANNER_COPY = 'Quick security check in progress — cart updates are paused for a moment.';
  var CLEARED_COPY = 'Security check cleared — you can keep shopping.';
  var ADD_ERROR_COPY = 'Unable to add item to cart. Please try again.';
  var bannerEl = null;
  var toastEl = null;
  var toastTimer = null;
  var stylesReady = false;

  function getThemeString(key, fallback) {
    var strings = root.theme && root.theme.strings;
    var value = strings && strings[key];
    return value || fallback;
  }

  function getEventDetail(evt) {
    return evt && evt.detail && typeof evt.detail === 'object' ? evt.detail : {};
  }

  function ensureStyles() {
    if (stylesReady) {
      return;
    }
    if (doc.getElementById && doc.getElementById(STYLE_ID)) {
      stylesReady = true;
      return;
    }
    if (!doc.createElement || (!doc.head && !doc.body)) {
      return;
    }

    var style = doc.createElement('style');
    style.setAttribute('id', STYLE_ID);
    // The sticky header wrapper creates a z-index:6 stacking context, so the
    // drawer's z-index:99999 is trapped there and the body-level banner
    // (z-index:9000) paints above the drawer edge. pointer-events:none keeps it
    // informational only; the visual overlap is accepted.
    style.textContent = '.hc-cart-challenge-banner{position:fixed;top:12px;left:12px;right:12px;z-index:9000;text-align:center;line-height:1.4;pointer-events:none;}' +
      '.hc-cart-challenge-banner__pill{display:inline-block;max-width:720px;width:auto;box-sizing:border-box;background:#111;color:#fff;border-radius:999px;padding:10px 16px;font-size:13px;box-shadow:0 8px 24px rgba(0,0,0,.18);}' +
      '.hc-cart-notice-toast{position:fixed;top:64px;right:16px;z-index:9001;max-width:420px;width:calc(100vw - 32px);box-sizing:border-box;background:#111;color:#fff;border-radius:6px;padding:12px 16px;font-size:14px;line-height:1.35;box-shadow:0 10px 30px rgba(0,0,0,.22);opacity:0;transform:translateY(-6px);transition:opacity .18s ease,transform .18s ease;}' +
      '.hc-cart-notice-toast.is-visible{opacity:1;transform:translateY(0);}' +
      '@media (max-width:767px){.hc-cart-challenge-banner{top:10px;left:10px;right:10px;}.hc-cart-challenge-banner__pill{font-size:12px;padding:9px 12px;max-width:calc(100vw - 20px);}.hc-cart-notice-toast{top:60px;right:12px;width:calc(100vw - 24px);font-size:13px;}}';
    (doc.head || doc.body).appendChild(style);
    stylesReady = true;
  }

  function addActiveClass() {
    if (doc.documentElement && doc.documentElement.classList) {
      doc.documentElement.classList.add(ACTIVE_CLASS);
    }
  }

  function removeActiveClass() {
    if (doc.documentElement && doc.documentElement.classList) {
      doc.documentElement.classList.remove(ACTIVE_CLASS);
    }
  }

  function showNow(element) {
    var raf = root.requestAnimationFrame || function(callback) { callback(); };
    raf(function() {
      if (element.className.indexOf('is-visible') === -1) {
        element.className += ' is-visible';
      }
    });
  }

  function removeElement(element) {
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  function removeBanner() {
    removeElement(bannerEl);
    bannerEl = null;
  }

  function setPoliteStatus(element) {
    element.setAttribute('role', 'status');
    element.setAttribute('aria-live', 'polite');
    element.setAttribute('aria-atomic', 'true');
  }

  function deferText(element, message) {
    element.textContent = '';
    if (typeof root.setTimeout === 'function') {
      root.setTimeout(function() {
        if (element.parentNode) {
          element.textContent = message;
        }
      }, 0);
    } else {
      element.textContent = message;
    }
  }

  function banner(message) {
    if (!message || !doc.body || !doc.createElement) {
      return null;
    }

    ensureStyles();

    if (!bannerEl || !bannerEl.parentNode) {
      bannerEl = doc.createElement('div');
      bannerEl.setAttribute('id', BANNER_ID);
      bannerEl.setAttribute('data-ib-cart-notice', 'banner');
      bannerEl.className = 'hc-cart-challenge-banner';
      // Security-check state is useful progress information, not an emergency.
      // Use polite status updates instead of alert/assertive interruption.
      setPoliteStatus(bannerEl);
      doc.body.appendChild(bannerEl);
    }

    bannerEl.innerHTML = '';
    var pill = doc.createElement('span');
    pill.className = 'hc-cart-challenge-banner__pill';
    bannerEl.appendChild(pill);
    deferText(pill, message);
    return bannerEl;
  }

  function clearToastTimer() {
    if (toastTimer && typeof root.clearTimeout === 'function') {
      root.clearTimeout(toastTimer);
    }
    toastTimer = null;
  }

  function removeToast() {
    removeElement(toastEl);
    toastEl = null;
  }

  function dismissToast() {
    clearToastTimer();
    removeToast();
  }

  function toast(message, durationMs) {
    if (!message || !doc.body || !doc.createElement) {
      return null;
    }
    // Default suits rare, important notices (errors, challenge cleared);
    // rapid-interaction hints pass a shorter duration.
    durationMs = typeof durationMs === 'number' && durationMs > 0 ? durationMs : 6000;

    ensureStyles();
    clearToastTimer();
    removeToast();

    toastEl = doc.createElement('div');
    toastEl.setAttribute('id', TOAST_ID);
    toastEl.setAttribute('data-ib-cart-notice', 'toast');
    toastEl.className = 'hc-cart-notice-toast';
    // Challenge notices are not emergencies; keep the live region polite.
    setPoliteStatus(toastEl);
    doc.body.appendChild(toastEl);
    deferText(toastEl, message);
    showNow(toastEl);

    if (typeof root.setTimeout === 'function') {
      toastTimer = root.setTimeout(function() {
        removeToast();
        toastTimer = null;
      }, durationMs);
    }

    return toastEl;
  }

  root.IBCartNotice = {
    banner: banner,
    toast: toast
  };

  if (doc.addEventListener) {
    doc.addEventListener('cart:challenge:active', function() {
      dismissToast();
      banner(getThemeString('cartChallengeActive', BANNER_COPY));
      addActiveClass();
    });

    doc.addEventListener('cart:challenge:cleared', function() {
      removeBanner();
      removeActiveClass();
      toast(getThemeString('cartChallengeCleared', CLEARED_COPY));
    });

    doc.addEventListener('cart:add:error', function(evt) {
      var detail = getEventDetail(evt);
      if (detail.renderedInline || detail.selfRendered || detail.suppressedByChallenge) {
        return;
      }
      if (toast(detail.message || ADD_ERROR_COPY)) {
        detail.renderedToast = true;
      }
    });
  }
})(window);
